import { render, staticRenderFns } from "./GetScheme.vue?vue&type=template&id=4f1b929c&scoped=true"
import script from "./GetScheme.vue?vue&type=script&lang=js"
export * from "./GetScheme.vue?vue&type=script&lang=js"
import style0 from "./GetScheme.vue?vue&type=style&index=0&id=4f1b929c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b929c",
  null
  
)

export default component.exports